import { Injectable } from '@angular/core';
import { TicketSource } from '../enums/ticket-source.enum';
import { CommonDataService } from './common-data.service';

@Injectable({
    providedIn: 'root',
})
export class SignatureService {
    constructor(private commonDataService: CommonDataService) {}

    getSignature(ticketSource: TicketSource) {
        if (this.commonDataService.isOneTime) {
            return '';
        }

        let result = '';
        switch (ticketSource) {
            case TicketSource.chat:
                result = '<br>' + (this.commonDataService.signatures.chat.text || '');
                break;
            case TicketSource.facebook:
                result = '<br>' + (this.commonDataService.signatures.facebook.text || '');
                break;
            case TicketSource.instagram:
                result = '<br>' + (this.commonDataService.signatures.instagram.text || '');
                break;
            case TicketSource.youtube:
                result = '<br>' + (this.commonDataService.signatures.youtube.text || '');
                break;
            case TicketSource.googleMyBusiness:
                result = '<br>' + (this.commonDataService.signatures.googleMyBusiness.text || '');
                break;
            case TicketSource.trustpilot:
                result = '<br>' + (this.commonDataService.signatures.trustpilot.text || '');
                break;
            case TicketSource.googlePlayMarket:
                result = '<br>' + (this.commonDataService.signatures.googlePlayMarket.text || '');
                break;
            case TicketSource.appStore:
                result = '<br>' + (this.commonDataService.signatures.appStore.text || '');
                break;
            case TicketSource.whatsApp:
                result = '<br>' + (this.commonDataService.signatures.whatsApp.text || '');
                break;
            case TicketSource.tikTok:
                result = '<br>' + (this.commonDataService.signatures.tikTok.text || '');
                break;
            case TicketSource.email:
            case TicketSource.form:
            case TicketSource.api:
                result = '<br>' + (this.commonDataService.signatures.socialBoards.text || '');
        }

        if (result === '\n' || result === '<br>') {
            result = '';
        }

        return result;
    }

    getSignatureStatus(ticketSource: TicketSource) {
        if (this.commonDataService.isOneTime) {
            return false;
        }

        switch (ticketSource) {
            case TicketSource.chat:
                return this.commonDataService.signatures.chat.isAuto;
            case TicketSource.form:
            case TicketSource.email:
            case TicketSource.api:
                return this.commonDataService.signatures.socialBoards.isAuto;
            case TicketSource.facebook:
                return this.commonDataService.signatures.facebook.isAuto;
            case TicketSource.instagram:
                return this.commonDataService.signatures.instagram.isAuto;
            case TicketSource.youtube:
                return this.commonDataService.signatures.youtube.isAuto;
            case TicketSource.googleMyBusiness:
                return this.commonDataService.signatures.googleMyBusiness.isAuto;
            case TicketSource.trustpilot:
                return this.commonDataService.signatures.trustpilot.isAuto;
            case TicketSource.googlePlayMarket:
                return this.commonDataService.signatures.googlePlayMarket.isAuto;
            case TicketSource.appStore:
                return this.commonDataService.signatures.appStore.isAuto;
            case TicketSource.whatsApp:
                return this.commonDataService.signatures.whatsApp.isAuto;
            case TicketSource.tikTok:
                return this.commonDataService.signatures.tikTok.isAuto;
            default:
                return false;
        }
    }
}
